import { SingleItemResponse } from '../../items/slice/types';
import { Gasket, StockResponse, StockData } from './types';
import { itemMedia } from '../../../../utils/itemMedia';
import { groupAttributes } from 'utils/groupAttributes';

export const transformStandardGasketsDTO: (
  gasketsDTO: SingleItemResponse[],
) => Gasket[] = gasketsDTO => {
  return gasketsDTO.map(gasket => ({
    description: gasket.description,
    erpPartNumber: gasket.erpPartNumber,
    image: itemMedia(gasket.medias, 'product image')[0],
    logos: itemMedia(gasket.medias, 'product icon'),
    partNumber: gasket.partNumber,
    productId: gasket.productId,
    attributes: groupAttributes(gasket.attributes),
    isStandard: true,
    englishDescription: gasket.englishDescription,
    type: '',
    dataSheet: '',
    brand: gasket.brand,
    length: gasket.length,
    width: gasket.width,
    thickness: gasket.thickness,
    configuration: gasket.configuration,
    series: gasket.series,
    price: {
      isLoading: false,
      error: null,
      data: null,
      itemQuantity: 1,
    },
    addToCart: {
      isLoading: false,
      error: null,
      data: false,
    },
    stockStatus: {
      isLoading: false,
      error: null,
      data: null,
    },
  }));
};

export const transformStockDTO: (
  stockDTO: StockResponse,
) => StockData = stockDTO => {
  const stockStatusMap = {
    CompletelyOnStock: 'inStock',
    NothingOnStock: 'outOfStock',
    Unavailable: 'infoUnavailable',
  };
  const index = stockDTO.available || '';
  return {
    deliveryDate: stockDTO.deliveryDate,
    available: stockStatusMap[index],
  };
};
